<template>
  <b-modal ref="modalImportFichierCotation" scrollable size="lg" title="Importer un fichier de cotation"
      ok-title="Fermer"
      :ok-only=true
      :ok-disabled="!resultatImportFichier"
      :hide-header-close="fichierEnCours"
      no-close-on-backdrop
      @show="initialiserModale()"
      @ok="fermerImport()">
      <template slot="default">
        <div style="display: inline">
          <div class="container-fluid card card-body">
            <div class="row importFichier">
              <div class="col-2">
                <button class="btn btn-primary" @click="$refs.importCotations.click()">Choisir Fichier</button>
                <input type="file" accept=".xls,.xlsx,.zip" @change="choisirFichierCotation($event)" style="display: none" ref="importCotations" />
              </div>
              <div class="col-8 importFichier">
                <label>{{ nomDuFichier }}</label>
              </div>
              <div class="col-2 aligner-droite">
                <button :disabled="nomDuFichier == ''" class="btn btn-success" @click="importerFichierCotation()">Importer</button>
              </div>
            </div>
          </div>

          <div v-if="!resultatImportFichier && fichierEnCours" class="container-fluid card card-body">
            <div class="row">
              <div class="col-12 form-group">
                <i class="fas fa-spinner fa-spin mr-2"></i>{{ etatImportFichier }}
              </div>  
            </div>
          </div>

          

          <div v-if="resultatImportFichier"> <!--On affiche une ligne par fichier avec le résultat général-->
            <div class="container-fluid card card-body">
              <template v-for="(resultat, iResultat) in resultatImportFichier">
                
                <div class="row" :key="'result-'+iResultat" :id="'nomFichier-'+iResultat" :href="'#detailErreur-'+iResultat">
                  <div class="col-12 form-group">
                    <i :class="[{'fas fa-exclamation-circle text-error mr-2':resultat && !resultat.fichierValide},
                                {'fas fa-check-circle text-success mr-2':resultat && resultat.fichierValide && !resultat.listeErreurs.some(x => x.warning)},
                                {'fas fa-exclamation-circle text-warning mr-2':resultat && resultat.fichierValide && resultat.listeErreurs.some(x => x.warning)}]"></i>
                    <span>{{ resultat.etatImportFichier }}</span>
                  </div>
                </div>

                <div v-if="!resultat.fichierValide || (resultat.fichierValide && resultat.listeErreurs.some(e => e.warning) )" :id="'detailErreur-'+iResultat" :aria-labelledby="'detailErreur-'+iResultat" class="row" :key="'resultErreur-'+iResultat">
                  <div class="col-12 form-group">
                    <table class="table table-bordered table-sm text-center">
                      <colgroup>
                        <col width="200">
                        <col>
                      </colgroup>
                      <thead class="table-header-secondary">
                        <th>Désignation Produit</th>
                        <th>Message d'erreur</th>
                      </thead>
                      <tbody>
                        <template v-for="(msg, iMsg) in resultat.listeErreurs">
                          <tr class="separateur" :key="'msg-'+iMsg">
                            <td class="aligner-gauche">
                              {{ msg.designationAgap }}
                            </td>
                            <td class="aligner-gauche">
                              {{ msg.erreur }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div v-if="FTEnCours" class="container-fluid card card-body">
            <template v-for="(resultat, iResultat) in resultatImportFT">
              <div class="row" :key="'resultFT-'+iResultat">
                <div class="col-12 form-group">
                  <i :class="[{'fas fa-spinner fa-spin mr-2':resultat && resultat.fichierEnCours },
                              {'fas fa-exclamation-circle text-error mr-2':resultat && !resultat.fichierEnCours && !resultat.fichierTraiteSucess},
                              {'fas fa-check-circle text-primary mr-2':resultat && !resultat.fichierEnCours && resultat.fichierTraiteSucess},
                             ]"></i>{{ resultat.etatImport }} 
                </div>  
              </div>
            </template>
          </div>

          <div v-if="resultatImportFichier && resultatImportFichier.some(x => x.fichierValide)" class="container-fluid card card-body">
            <div class="row">
              <div class="col-12 form-group">
                <em>
                  <p v-if="FTEnCours">
                    Le téléchargement des fiches techniques se poursuivra même si vous fermez cette fenêtre.
                  </p>
                  <p>
                    Merci de vérifier vos propositions avant de les envoyer
                  </p>
                </em>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
</template>

<script>

import { importerPropositions, copierFichesTechniques, calculerCAPropositions } from '@/api/gpao/propositions'
import { connecteData } from "@/mixins/connecteData"
import { arrondiMercuriale } from '../helpers/utils'

export default {
  name: "ModalImportFichierCotation",
  props: {
    datePropoId: {type: Number}
  },
  mixins: [ connecteData ],
  data() {
    return {
      resultatImportFichier: null,
      resultatImportFT: null,
      fichierEnCours: false,
      FTEnCours: false,
      etatImportFichier: "",
      formData: null,
      selectedFile: null,
    }
  },
  watch: {
    
  },
  computed: {
    contenuDuFichier() {
      return this.formData ?? new FormData()
    },
    nomDuFichier() {
      return this.selectedFile?.name ?? ""
    },

  },
  methods: {

    initialiserModale() {
      //on affiche la modale de suivi du chargement avec l'etat initial
      this.etatImportFichier = "Controle et chargement du fichier en cours ..."
      //this.resultatImportFichier = null
    },
    choisirFichierCotation(event) {
      //on récupère le fichier à traiter
      this.fichierEnCours = false
      if (event.target.files.length != 0) {
        this.formData = new FormData();
        this.selectedFile = event.target.files[0];

        if (this.selectedFile.size > (1024 * 1024 * 100)) {
          // Fichier de 100 Mo maximum
          this.alerteErreur("Le fichier que vous tentez d'importer est trop volumineux (" + arrondiMercuriale(this.selectedFile.size / 1024 / 1024) + " Mo). Taille maximale : 100 Mo.")
          return
        }

        this.formData.append('fichierCotation', this.selectedFile);
      }
    },
    async copierFT(listeFichier) {
      
      if (listeFichier.length > 0) {
        this.resultatImportFT = []
        
        this.FTEnCours = true
        var toGet=[];
        listeFichier.forEach(f => {
          let debutMessage = "Téléchargement des " + f.nombreFichesTechniquesATraiter + " fiches techniques du fichier "
          this.resultatImportFT.push({nomFichier: f.nomFichier, nombreFT: f.nombreFichesTechniquesATraiter, fichierEnCours: true, fichierTraiteSucess: false, etatImport: debutMessage + f.nomFichier + " en cours ..."})
          let promiseFile =  copierFichesTechniques(this.fournisseurCourantId, this.datePropoId, f.familleId, true, 300000 + (listeFichier.length * 60000)) //On met le timeout à 5 minutes plus 1 minute par fichier envoyé .... plus on envoie de fichier plus le téléchargement peut prendre du temps :-(
                .then((r) => {
                    let res = this.resultatImportFT.find(x => x.nomFichier === f.nomFichier); 
                    res.fichierEnCours=false; 
                    res.fichierTraiteSucess=true; 
                    res.etatImport=debutMessage + f.nomFichier + " terminé."
                    //console.log("Fin récupération FT du fichier " + f.nomFichier)
                    return r
                  })
                .catch((ex) => {
                    //Le back Espace Fournisseur à capter l'erreur et mis à jour les propos, donc ici on affiche juste l'erreur dans la modale si elle est toujours visible
                    let res = this.resultatImportFT.find(x => x.nomFichier === f.nomFichier); 
                    res.fichierEnCours=false; 
                    res.fichierTraiteSucess=false
                    res.etatImport=debutMessage + f.nomFichier + " en erreur."
                    return ex
                  })
                
          toGet.push(promiseFile)
        })

        //console.log("Récupération FT de tous les fichiers en cours")

        await Promise.all(toGet)
        
        //console.log("Récupération FT de tous les fichiers terminé")
      }       
    },

    async calculerCA(listeFichier) {
      //Permet de lancer en asynchrone le calcul des CA pour les propos chargées depuis les fichiers de cotations
      //Ne plus faire, le CA est calculé par Alfred directement sur les articles fournisseurs
      if (listeFichier.length > 0) {
        var toGet=[];
        listeFichier.forEach(f => {
          toGet.push(calculerCAPropositions(this.fournisseurCourantId, this.datePropoId, f.familleId))
        })

        await Promise.all(toGet)
      }       
    },
    async importerFichierCotation() {
      this.fichierEnCours = true
      this.resultatImportFichier = null
      this.FTEnCours = false

      //on appel l'API de chargement du fichier et on affiche le résultat dans la modale, via la variable resultatImportFichier
      try {
        let resp = await importerPropositions(this.fournisseurCourantId, this.datePropoId, this.contenuDuFichier);
        this.resultatImportFichier = resp.data
        //On lance le téléchargement des fiches Techniques pour les fichiers OK (ou en Warning) en asynchrone et avec des liens de FT à traiter
        this.copierFT(this.resultatImportFichier.filter(f => f.fichierValide && f.fichesTechniquesATraiter))
      } catch {
        let res = {
          nomFichier: "",
          familleId: null,
          famille: null,
          fichierValide: false,
          fichesTechniquesATraiter: false,
          nombreFichesTechniquesATraiter: 0,
          listeErreurs: [],
          etatImportFichier: "Fichier non importé"
        }

        let err = {
          numeroLigne: null,
          designationAgap: "",
          erreur: "Erreur technique lors de l'import du fichier. Merci de fermer la fenêtre et de réessayer.",
          warning: false
        }

        res.listeErreurs.push(err)
        
        this.resultatImportFichier = []
        this.resultatImportFichier.push(res)
        this.fichierEnCours = false
      }
      
      //this.calculerCA(this.resultatImportFichier.filter(f => f.fichierValide))
    },
    fermerImport() {
      if (this.resultatImportFichier) {
        this.$emit("rechargerPropo")
        this.hide()  
      }
    },
    show() {
      this.selectedFile = null
      this.formData = new FormData()
      this.$refs.modalImportFichierCotation.show()
    },
    hide() {
      if (this.resultatImportFichier) {
        this.$refs.modalImportFichierCotation.hide()
      }
    }
  }
}
</script>